export const NOTIFICATION = {
    NOTIFICATION: "notification",
    TOAST: "toast",
}

export const ACCOUNT_IFSC_CODE = 'SURY0BK0000'

export const PORTFOLIO_POLLING_TIME = 30000

export const DEFAULT_SAVINGS_BANK_FOR_USER = 'SSFB Bank';

export const DEFAULT_ACCOUNT_TYPE_FOR_USER = 'SAVINGS';

export const BANK_ACCOUNT_LABELS = {
    SAVING_ACCOUNT: 'Saving Account',
    TOTAL_BALANCE: 'Total Balance',
    NET_AVAILABLE_BALANCE: 'Net Available Balance',
    BLOCKED_AMOUNT: 'Blocked Amount',
    ACCOUNT_HOLDER_NAME: 'Account Holder Name',
    ACCOUNT_NUMBER: 'Account Number',
    ACCOUNT_TYPE: 'Account Type',
    IFSC_CODE: 'IFSC Code',
  };

  export const VKYC_STATUS ={
    COMPLETED:"Completed",
    REJECTED:"Rejected"
  }